<template>
    <div class="cookies-block" v-if="showCookiesBlock">
        <div class="cookies__content">
            <p>
                Þessi síða notar fótspor (e. cookies) vegna nauðsynlegrar virkni hennar og til að safna tölfræðigögnum
                með þeim tilgangi að gera síðuna betri.
            </p>
        </div>
        <div class="cookies__btns">
            <router-link to="/about-project#skilmalar" class="cookies__link">
                Frekari upplýsingar
            </router-link>
            <a href="javascript:void(0);" class="btn-default cookie__btn" @click="setCookies">
                ÉG SAMÞYKKI
            </a>
        </div>
    </div>
</template>

<script>
    import inIframe from "@/helpers/inIframe";
    export default {
        data: () => ({
            showCookiesBlock: true
        }),
        methods: {
            hideBlock() {
                this.showCookiesBlock = false;
                if (!inIframe())
                    localStorage.setItem('useOfCookies', '1');
            },
            setCookies() {
                document.cookie = "useOfCookies=true"
                this.hideBlock()
            },
            checkUseCookie() {
                const cookie = document.cookie.split('; ')
                cookie.forEach(el => {
                    if (el === "useOfCookies=true") {
                        this.showCookiesBlock = false
                    }
                });

                if (!inIframe() && localStorage.getItem('useOfCookies') == 1) {
                    this.showCookiesBlock = false
                }
            }
        },
        created() {
            this.checkUseCookie()
        }
    }
</script>
